import { Mark, mergeAttributes } from '@tiptap/core'

export const CommentMark = Mark.create({
  name: 'comment',
  
  addAttributes() {
    return {
      commentId: {
        default: null,
        parseHTML: element => element.getAttribute('data-comment-id'),
        renderHTML: attributes => {
          if (!attributes.commentId) return {}
          return { 'data-comment-id': attributes.commentId }
        }
      }
    }
  },
  
  parseHTML() {
    return [{ tag: 'span.comment-highlight' }]
  },
  
  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes({ class: 'comment-highlight' }, HTMLAttributes), 0]
  }
})
